// extracted by mini-css-extract-plugin
export var body = "Dnk5KQxkNsF_IPWlIpdZ";
export var hero = "O8qp1xcRj_F4yPMHOknh";
export var large = "q6lfaU6e8jAwNLfxH6yK";
export var micro = "izAjVIlRc8skfqV8_HwF";
export var mini = "mZA8Mg1oUpaGFZRtsFSw";
export var small = "OViTfKF04lFlkeOfbntD";
export var title1 = "Wvd1FoRB69LSevKmqWLL";
export var title2 = "xnjH416jHywKKAQXECGq";
export var title3 = "V2uaAAINz3ArDFdfnoGN";